import { Component, OnInit, Optional } from '@angular/core';
import { JeevesDeliveryAddressesService, SummarizeOrderJeevesComponent } from 'gung-standard-jeeves';
import { CustomerService, ProductService, AuthService, PriceService, GungFlowService, GungGoogleTagManagerService } from 'gung-standard';
import { DateUtilService } from 'gung-common';
import { first } from 'rxjs';

@Component({
  selector: 'cult-summarize-order',
  templateUrl: './cult-summarize-order.component.html',
  styleUrls: ['./cult-summarize-order.component.scss']
})
export class CultSummarizeOrderComponent extends SummarizeOrderJeevesComponent implements OnInit {
  isReturNoPrice = false;

  customerBilling = {}
  constructor(
    protected customerService: CustomerService,
    protected productService: ProductService,
    protected authService: AuthService,
    protected priceService: PriceService,
    public dateUtilService: DateUtilService,
    protected gungFlowService: GungFlowService,
    protected jeevesDeliveryAddressesService: JeevesDeliveryAddressesService,
    @Optional()
    protected gungGoogleTagManagerService: GungGoogleTagManagerService
  ) {
    super(customerService, productService, authService, priceService, dateUtilService, jeevesDeliveryAddressesService, gungGoogleTagManagerService);
  }


  ngOnInit(): void {
    super.ngOnInit();
    this.authService
      .getCurrentUser()
      .pipe(first())
      .subscribe(user => {
        this.isReturNoPrice = user.roles.includes('RETUR_NOPRICE');
      });
    this.customerBilling = this.customer.extra._billing || {}
  }
}
